export default __webpack_public_path__ + "static/media/KNX Scientific.bbe24f81.jpeg";